import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "gridOption", "suburbOption",
    "gridRadio", "suburbRadio",
    "gridIndicator", "suburbIndicator",
    "gridDot", "suburbDot",
    "gridFields", "suburbFields",
    "gridAdvanced",
    "countrySelect", "stateSelect",
    "suburbListContainer", "suburbList", "suburbFilter",
    "suburbSummary", "suburbCost",
    "aiSummaryFields"
  ]

  // Track loaded suburbs and selections
  allSuburbs = []
  selectedSuburbs = new Set()
  lockedSuburbs = new Set() // Suburbs that already exist and can't be removed (edit mode)

  // State data - must match database exactly
  statesByCountry = {
    "Australia": ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
    "United States": ["AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"],
    "United Kingdom": ["Aberdeen City", "Aberdeenshire", "Adur", "Amber Valley", "Angus", "Antrim and Newtownabbey", "Ards and North Down", "Argyll and Bute", "Armagh City, Banbridge and Craigavon", "Arun", "Ashfield", "Ashford", "Babergh", "Barking and Dagenham", "Barnet", "Barnsley", "Basildon", "Basingstoke and Deane", "Bassetlaw", "Bath and North East Somerset", "Bedford", "Belfast", "Bexley", "Birmingham", "Blaby", "Blackburn with Darwen", "Blackpool", "Blaenau Gwent", "Bolsover", "Bolton", "Boston", "Bournemouth, Christchurch and Poole", "Bracknell Forest", "Bradford", "Braintree", "Breckland", "Brent", "Brentwood", "Bridgend", "Brighton and Hove", "Bristol, City of", "Broadland", "Bromley", "Bromsgrove", "Broxbourne", "Broxtowe", "Buckinghamshire", "Burnley", "Bury", "Caerphilly", "Calderdale", "Cambridge", "Camden", "Cannock Chase", "Canterbury", "Cardiff", "Carmarthenshire", "Castle Point", "Causeway Coast and Glens", "Central Bedfordshire", "Ceredigion", "Charnwood", "Chelmsford", "Cheltenham", "Cherwell", "Cheshire East", "Cheshire West and Chester", "Chesterfield", "Chichester", "Chorley", "City of Edinburgh", "City of London", "Clackmannanshire", "Colchester", "Conwy", "Cornwall", "Cotswold", "County Durham", "Coventry", "Crawley", "Croydon", "Cumberland", "Dacorum", "Darlington", "Dartford", "Denbighshire", "Derby", "Derbyshire Dales", "Derry City and Strabane", "Doncaster", "Dorset", "Dover", "Dudley", "Dumfries and Galloway", "Dundee City", "Ealing", "East Ayrshire", "East Cambridgeshire", "East Devon", "East Dunbartonshire", "East Hampshire", "East Hertfordshire", "East Lindsey", "East Lothian", "East Renfrewshire", "East Riding of Yorkshire", "East Staffordshire", "East Suffolk", "Eastbourne", "Eastleigh", "Elmbridge", "Enfield", "Epping Forest", "Epsom and Ewell", "Erewash", "Exeter", "Falkirk", "Fareham", "Fenland", "Fermanagh and Omagh", "Fife", "Flintshire", "Folkestone and Hythe", "Forest of Dean", "Fylde", "Gateshead", "Gedling", "Glasgow City", "Gloucester", "Gosport", "Gravesham", "Great Yarmouth", "Greenwich", "Guildford", "Gwynedd", "Hackney", "Halton", "Hammersmith and Fulham", "Harborough", "Haringey", "Harlow", "Harrow", "Hart", "Hartlepool", "Hastings", "Havant", "Havering", "Herefordshire, County of", "Hertsmere", "High Peak", "Highland", "Hillingdon", "Hinckley and Bosworth", "Horsham", "Hounslow", "Huntingdonshire", "Hyndburn", "Inverclyde", "Ipswich", "Isle of Anglesey", "Isle of Wight", "Isles of Scilly", "Islington", "Kensington and Chelsea", "King's Lynn and West Norfolk", "Kingston upon Hull, City of", "Kingston upon Thames", "Kirklees", "Knowsley", "Lambeth", "Lancaster", "Leeds", "Leicester", "Lewes", "Lewisham", "Lichfield", "Lincoln", "Lisburn and Castlereagh", "Liverpool", "Luton", "Maidstone", "Maldon", "Malvern Hills", "Manchester", "Mansfield", "Medway", "Melton", "Merthyr Tydfil", "Merton", "Mid Devon", "Mid Suffolk", "Mid Sussex", "Mid Ulster", "Mid and East Antrim", "Middlesbrough", "Midlothian", "Milton Keynes", "Mole Valley", "Monmouthshire", "Moray", "Na h-Eileanan Siar", "Neath Port Talbot", "New Forest", "Newark and Sherwood", "Newcastle upon Tyne", "Newcastle-under-Lyme", "Newham", "Newport", "Newry, Mourne and Down", "North Ayrshire", "North Devon", "North East Derbyshire", "North East Lincolnshire", "North Hertfordshire", "North Kesteven", "North Lanarkshire", "North Lincolnshire", "North Norfolk", "North Northamptonshire", "North Somerset", "North Tyneside", "North Warwickshire", "North West Leicestershire", "North Yorkshire", "Northumberland", "Norwich", "Nottingham", "Nuneaton and Bedworth", "Oadby and Wigston", "Oldham", "Orkney Islands", "Oxford", "Pembrokeshire", "Pendle", "Perth and Kinross", "Peterborough", "Plymouth", "Portsmouth", "Powys", "Preston", "Reading", "Redbridge", "Redcar and Cleveland", "Redditch", "Reigate and Banstead", "Renfrewshire", "Rhondda Cynon Taf", "Ribble Valley", "Richmond upon Thames", "Rochdale", "Rochford", "Rossendale", "Rother", "Rotherham", "Rugby", "Runnymede", "Rushcliffe", "Rushmoor", "Rutland", "Salford", "Sandwell", "Scottish Borders", "Sefton", "Sevenoaks", "Sheffield", "Shetland Islands", "Shropshire", "Slough", "Solihull", "Somerset", "South Ayrshire", "South Cambridgeshire", "South Derbyshire", "South Gloucestershire", "South Hams", "South Holland", "South Kesteven", "South Lanarkshire", "South Norfolk", "South Oxfordshire", "South Ribble", "South Staffordshire", "South Tyneside", "Southampton", "Southend-on-Sea", "Southwark", "Spelthorne", "St Albans", "St. Helens", "Stafford", "Staffordshire Moorlands", "Stevenage", "Stirling", "Stockport", "Stockton-on-Tees", "Stoke-on-Trent", "Stratford-on-Avon", "Stroud", "Sunderland", "Surrey Heath", "Sutton", "Swale", "Swansea", "Swindon", "Tameside", "Tamworth", "Tandridge", "Teignbridge", "Telford and Wrekin", "Tendring", "Test Valley", "Tewkesbury", "Thanet", "Three Rivers", "Thurrock", "Tonbridge and Malling", "Torbay", "Torfaen", "Torridge", "Tower Hamlets", "Trafford", "Tunbridge Wells", "Uttlesford", "Vale of Glamorgan", "Vale of White Horse", "Wakefield", "Walsall", "Waltham Forest", "Wandsworth", "Warrington", "Warwick", "Watford", "Waverley", "Wealden", "Welwyn Hatfield", "West Berkshire", "West Devon", "West Dunbartonshire", "West Lancashire", "West Lindsey", "West Lothian", "West Northamptonshire", "West Oxfordshire", "West Suffolk", "Westminster", "Westmorland and Furness", "Wigan", "Wiltshire", "Winchester", "Windsor and Maidenhead", "Wirral", "Woking", "Wokingham", "Wolverhampton", "Worcester", "Worthing", "Wrexham", "Wychavon", "Wyre", "Wyre Forest", "York"]
  }

  connect() {
    // Add click handlers to the option labels for better UX
    if (this.hasGridOptionTarget) {
      this.gridOptionTarget.addEventListener('click', () => this.selectGrid())
    }
    if (this.hasSuburbOptionTarget) {
      this.suburbOptionTarget.addEventListener('click', () => this.selectSuburb())
    }

    // Check if we're editing a suburb search (no radio buttons, but gridFields is already hidden)
    // In this case, don't override the visibility set by the server
    const isEditingSuburbSearch = !this.hasGridRadioTarget && !this.hasSuburbRadioTarget &&
      this.hasGridFieldsTarget && this.gridFieldsTarget.classList.contains('hidden')

    if (isEditingSuburbSearch) {
      // We're editing a suburb search - load the suburbs for adding new ones
      this.loadSuburbsForExistingSearch()
    } else if (this.hasGridRadioTarget && this.gridRadioTarget.checked) {
      this.selectGrid()
    } else if (this.hasSuburbRadioTarget && this.suburbRadioTarget.checked) {
      this.selectSuburb()
      // If editing an existing suburb search, load the suburbs
      if (this.hasCountrySelectTarget && this.countrySelectTarget.value &&
          this.hasStateSelectTarget && this.stateSelectTarget.value) {
        this.loadSuburbsForExistingSearch()
      }
    } else {
      // Default to grid (for new searches)
      this.selectGrid()
    }

    // If a country is already selected, populate states (preserving current selection)
    if (this.hasCountrySelectTarget && this.countrySelectTarget.value) {
      const currentState = this.hasStateSelectTarget ? this.stateSelectTarget.value : null
      this.populateStates(this.countrySelectTarget.value, currentState)
    }
  }

  // Load suburbs for an existing search being edited
  async loadSuburbsForExistingSearch() {
    // Get country/state values - either from select targets or hidden fields (edit mode)
    let country, state
    if (this.hasCountrySelectTarget) {
      country = this.countrySelectTarget.value
    } else {
      // In edit mode, read from hidden field
      const hiddenCountry = this.element.querySelector('input[name="companies_search[search_country]"]')
      country = hiddenCountry?.value
    }
    if (this.hasStateSelectTarget) {
      state = this.stateSelectTarget.value
    } else {
      // In edit mode, read from hidden field
      const hiddenState = this.element.querySelector('input[name="companies_search[search_state]"]')
      state = hiddenState?.value
    }

    if (!country || !state) return

    // Show suburb list container
    if (this.hasSuburbListContainerTarget) {
      this.suburbListContainerTarget.classList.remove('hidden')
    }

    // Load locked suburbs from the data attribute (suburbs that already exist and can't be removed)
    if (this.hasSuburbListTarget) {
      const existingSuburbsJson = this.suburbListTarget.dataset.existingSuburbs
      if (existingSuburbsJson) {
        try {
          const existingSuburbs = JSON.parse(existingSuburbsJson)
          this.lockedSuburbs = new Set(existingSuburbs)
        } catch (e) {
          console.error('Error parsing existing suburbs:', e)
        }
      }
    }

    // Show loading state
    if (this.hasSuburbListTarget) {
      this.suburbListTarget.innerHTML = '<p class="p-4 text-sm text-slate-500">Loading available suburbs...</p>'
    }

    try {
      const response = await fetch(`/api/v1/suburbs?country=${encodeURIComponent(country)}&state=${encodeURIComponent(state)}`)
      if (response.ok) {
        const data = await response.json()
        // Filter out locked suburbs - they're already being searched
        this.allSuburbs = (data.suburbs || []).filter(s => !this.lockedSuburbs.has(s.name))

        // Start with no new selections when editing
        this.selectedSuburbs = new Set()

        this.renderSuburbList()
        this.updateSuburbSummary()
      }
    } catch (error) {
      console.error('Error fetching suburbs:', error)
      if (this.hasSuburbListTarget) {
        this.suburbListTarget.innerHTML = '<p class="p-4 text-sm text-red-500">Could not load suburbs</p>'
      }
    }
  }

  selectGrid() {
    // Update radio states
    if (this.hasGridRadioTarget) this.gridRadioTarget.checked = true
    if (this.hasSuburbRadioTarget) this.suburbRadioTarget.checked = false

    // Update visual indicators
    this.updateIndicators('grid')

    // Show/hide appropriate fields
    if (this.hasGridFieldsTarget) this.gridFieldsTarget.classList.remove('hidden')
    if (this.hasGridAdvancedTarget) this.gridAdvancedTarget.classList.remove('hidden')
    if (this.hasSuburbFieldsTarget) this.suburbFieldsTarget.classList.add('hidden')

    // Clear residual suburb values to prevent false duplicate detection
    // Grid searches use location_bias, not country/state
    if (this.hasCountrySelectTarget) this.countrySelectTarget.value = ''
    if (this.hasStateSelectTarget) this.stateSelectTarget.value = ''
    this.selectedSuburbs.clear()
    this.allSuburbs = []
  }

  selectSuburb() {
    // Update radio states
    if (this.hasGridRadioTarget) this.gridRadioTarget.checked = false
    if (this.hasSuburbRadioTarget) this.suburbRadioTarget.checked = true

    // Update visual indicators
    this.updateIndicators('suburb')

    // Show/hide appropriate fields
    if (this.hasGridFieldsTarget) this.gridFieldsTarget.classList.add('hidden')
    if (this.hasGridAdvancedTarget) this.gridAdvancedTarget.classList.add('hidden')
    if (this.hasSuburbFieldsTarget) this.suburbFieldsTarget.classList.remove('hidden')
  }

  updateIndicators(selected) {
    // Grid indicator
    if (this.hasGridOptionTarget) {
      if (selected === 'grid') {
        this.gridOptionTarget.classList.add('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20')
        this.gridOptionTarget.classList.remove('border-slate-200', 'dark:border-slate-700')
        if (this.hasGridDotTarget) this.gridDotTarget.classList.remove('hidden')
      } else {
        this.gridOptionTarget.classList.remove('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20')
        this.gridOptionTarget.classList.add('border-slate-200', 'dark:border-slate-700')
        if (this.hasGridDotTarget) this.gridDotTarget.classList.add('hidden')
      }
    }

    // Suburb indicator
    if (this.hasSuburbOptionTarget) {
      if (selected === 'suburb') {
        this.suburbOptionTarget.classList.add('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20')
        this.suburbOptionTarget.classList.remove('border-slate-200', 'dark:border-slate-700')
        if (this.hasSuburbDotTarget) this.suburbDotTarget.classList.remove('hidden')
      } else {
        this.suburbOptionTarget.classList.remove('border-primary-500', 'bg-primary-50', 'dark:bg-primary-900/20')
        this.suburbOptionTarget.classList.add('border-slate-200', 'dark:border-slate-700')
        if (this.hasSuburbDotTarget) this.suburbDotTarget.classList.add('hidden')
      }
    }
  }

  countryChanged() {
    const country = this.countrySelectTarget.value
    this.populateStates(country)

    // Hide suburb list until state is selected
    if (this.hasSuburbListContainerTarget) {
      this.suburbListContainerTarget.classList.add('hidden')
    }
    this.allSuburbs = []
    this.selectedSuburbs.clear()
  }

  populateStates(country, preserveState = null) {
    if (!this.hasStateSelectTarget) return

    // Clear and populate state select
    this.stateSelectTarget.innerHTML = '<option value="">Select state...</option>'

    if (country && this.statesByCountry[country]) {
      this.statesByCountry[country].forEach(state => {
        const option = document.createElement('option')
        option.value = state
        option.textContent = state
        // Preserve the previously selected state if specified
        if (preserveState && state === preserveState) {
          option.selected = true
        }
        this.stateSelectTarget.appendChild(option)
      })
    }
  }

  async stateChanged() {
    const country = this.countrySelectTarget.value
    const state = this.stateSelectTarget.value

    if (country && state) {
      // Show suburb list container
      if (this.hasSuburbListContainerTarget) {
        this.suburbListContainerTarget.classList.remove('hidden')
      }

      // Show loading state
      if (this.hasSuburbListTarget) {
        this.suburbListTarget.innerHTML = '<p class="p-4 text-sm text-slate-500">Loading suburbs...</p>'
      }

      try {
        const response = await fetch(`/api/v1/suburbs?country=${encodeURIComponent(country)}&state=${encodeURIComponent(state)}`)
        if (response.ok) {
          const data = await response.json()
          this.allSuburbs = data.suburbs || []
          // Start with none selected - user must choose which suburbs to search
          this.selectedSuburbs = new Set()
          this.renderSuburbList()
          this.updateSuburbSummary()
        }
      } catch (error) {
        console.error('Error fetching suburbs:', error)
        if (this.hasSuburbListTarget) {
          this.suburbListTarget.innerHTML = '<p class="p-4 text-sm text-red-500">Could not load suburbs</p>'
        }
      }
    } else {
      if (this.hasSuburbListContainerTarget) {
        this.suburbListContainerTarget.classList.add('hidden')
      }
    }
  }

  renderSuburbList(filter = '') {
    if (!this.hasSuburbListTarget) return

    const filteredSuburbs = filter
      ? this.allSuburbs.filter(s => s.name.toLowerCase().includes(filter.toLowerCase()))
      : this.allSuburbs

    if (filteredSuburbs.length === 0) {
      this.suburbListTarget.innerHTML = '<p class="p-4 text-sm text-slate-500">No suburbs found</p>'
      return
    }

    const html = filteredSuburbs.map(suburb => `
      <label class="flex items-center px-3 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer border-b border-slate-100 dark:border-slate-700 last:border-b-0">
        <input type="checkbox"
               name="companies_search[selected_suburbs][]"
               value="${suburb.name}"
               ${this.selectedSuburbs.has(suburb.name) ? 'checked' : ''}
               class="rounded border-slate-300 text-primary-600 shadow-sm focus:border-primary-500 focus:ring-primary-500"
               data-action="change->search-type#toggleSuburb">
        <span class="ml-2 text-sm text-slate-700 dark:text-slate-300">${suburb.name}</span>
      </label>
    `).join('')

    this.suburbListTarget.innerHTML = html
  }

  toggleSuburb(event) {
    const suburbName = event.target.value
    if (event.target.checked) {
      this.selectedSuburbs.add(suburbName)
    } else {
      this.selectedSuburbs.delete(suburbName)
    }
    this.updateSuburbSummary()
  }

  selectAllSuburbs() {
    this.selectedSuburbs = new Set(this.allSuburbs.map(s => s.name))
    this.renderSuburbList(this.hasSuburbFilterTarget ? this.suburbFilterTarget.value : '')
    this.updateSuburbSummary()
  }

  deselectAllSuburbs() {
    this.selectedSuburbs.clear()
    this.renderSuburbList(this.hasSuburbFilterTarget ? this.suburbFilterTarget.value : '')
    this.updateSuburbSummary()
  }

  filterSuburbs() {
    const filter = this.hasSuburbFilterTarget ? this.suburbFilterTarget.value : ''
    this.renderSuburbList(filter)
  }

  updateSuburbSummary() {
    const newCount = this.selectedSuburbs.size
    const lockedCount = this.lockedSuburbs.size
    const totalCount = newCount + lockedCount

    // Cost estimate:
    // - Each suburb = 1 cell initially
    // - Each cell = ~3 API calls (max_pages default)
    // - Saturated cells subdivide into 4 (assume ~20% subdivide, ~10% of those subdivide again)
    // - Estimated cells per suburb = 1 + 0.2*4 + 0.02*16 ≈ 2.1
    // - API cost = $0.032 per call
    // Formula: suburbs * 2.1 cells * 3 calls * $0.032 = suburbs * $0.20
    const costPerSuburb = 0.20
    const estimatedCost = (newCount * costPerSuburb).toFixed(2)

    if (this.hasSuburbSummaryTarget) {
      if (lockedCount > 0 && newCount > 0) {
        this.suburbSummaryTarget.textContent = `${newCount.toLocaleString()} new suburb${newCount !== 1 ? 's' : ''} to add (${lockedCount} existing)`
      } else if (lockedCount > 0) {
        this.suburbSummaryTarget.textContent = `No new suburbs selected (${lockedCount} existing)`
      } else {
        this.suburbSummaryTarget.textContent = `${totalCount.toLocaleString()} suburb${totalCount !== 1 ? 's' : ''} selected`
      }
    }
    if (this.hasSuburbCostTarget) {
      if (lockedCount > 0) {
        this.suburbCostTarget.textContent = newCount > 0 ? `Est. additional cost: $${estimatedCost}` : ''
      } else {
        this.suburbCostTarget.textContent = `Est. cost: $${estimatedCost}`
      }
    }

    // Auto-set budget if suburbs selected and budget enabled
    this.updateBudgetEstimate(newCount, estimatedCost)
  }

  updateBudgetEstimate(suburbCount, estimatedCost) {
    // Find budget elements
    const budgetCheckbox = this.element.querySelector('input[name="companies_search[budget_enabled]"]')
    const budgetInput = this.element.querySelector('input[name="companies_search[budget_dollars]"]')

    if (!budgetInput) return

    // Only auto-fill if this is a new value (input is empty or was auto-set)
    const currentValue = budgetInput.value
    const isUserSet = budgetInput.dataset.userSet === 'true'

    if (suburbCount > 0 && !isUserSet) {
      // Set estimated budget (rounded up to nearest dollar for simplicity)
      const roundedBudget = Math.max(1, Math.ceil(parseFloat(estimatedCost)))
      budgetInput.value = roundedBudget.toFixed(2)
      budgetInput.dataset.autoSet = 'true'

      // Auto-enable budget checkbox
      if (budgetCheckbox && !budgetCheckbox.checked) {
        budgetCheckbox.checked = true
        // Trigger the toggle to show the budget fields
        budgetCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    // Track if user manually changes the budget
    if (!budgetInput.dataset.listenerAdded) {
      budgetInput.addEventListener('input', () => {
        budgetInput.dataset.userSet = 'true'
        budgetInput.dataset.autoSet = 'false'
      })
      budgetInput.dataset.listenerAdded = 'true'
    }
  }

  toggleAiSummary(event) {
    if (this.hasAiSummaryFieldsTarget) {
      if (event.target.checked) {
        this.aiSummaryFieldsTarget.classList.remove('hidden')
      } else {
        this.aiSummaryFieldsTarget.classList.add('hidden')
      }
    }
  }
}
